import { Component, OnInit, HostBinding } from '@angular/core';
import { CurrentApiService, IElement } from 'dbweb-core';
interface FetchDataResult {
	FromElement: string;
	Count: number;
}
interface RemoveselResult {
	TaskInfoURL: string; // å¯¹åºçæå¼ä»»å¡ä¿¡æ¯çURL
	TaskInfoSign: string; // ä¸è¿°çsign
	BrowseTaskElement: IElement;
}
@Component({
	selector: 'common-removesel',
	templateUrl: './removesel.component.html',
	styleUrls: ['./removesel.component.scss']
})
export class RemoveselComponent implements OnInit {
	@HostBinding('class.c-removesel') hostClass = true;
	constructor(private api: CurrentApiService) {}

	ngOnInit() {}
	apiFetchRemoveSelData() {
		return this.api.get<FetchDataResult>('fetch-data');
	}
	apiRemovesel() {
		return this.api.post<RemoveselResult>('removesel');
	}
}
